<div [class]="class" role="list">
  @for (spec of specs; track spec) {
  <div class="component" role="listitem">
    <ng-template component-host [spec]="spec"></ng-template>
  </div>
  }

  <ng-content></ng-content>
</div>
